import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { SendPostRequest } from "../../http";
import "./ResolutionSlider.css";

const ResolutionSlider = () => {
  const [slides, setSlides] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [titleVisible, setTitleVisible] = useState(false);
  const [descVisible, setDescVisible] = useState(false);
  const [tiltStyle, setTiltStyle] = useState({});
  const [showArrows, setShowArrows] = useState(false);
  const sitedata = useSelector((store) => store.global.loginData);

  const titleTimeout = useRef(null);
  const descTimeout = useRef(null);
  const slideTimeout = useRef(null);
  const arrowTimeout = useRef(null);

  useEffect(() => {
    fetchSlides();
  }, []);

  useEffect(() => {
    if (slides.length > 0) {
      startSlideShow();
    }

    return () => {
      // Clear all timeouts on unmount or slide change
      clearTimeout(titleTimeout.current);
      clearTimeout(descTimeout.current);
      clearTimeout(slideTimeout.current);
      clearTimeout(arrowTimeout.current);
    };
  }, [activeIndex, slides]);

  const fetchSlides = async () => {
    const siteTheme = sitedata?.options?.theme;
    const response = await SendPostRequest("branding/banners", {
      theme: siteTheme,
    });
    setSlides(response?.data || []);
  };

  const startSlideShow = () => {
    // Reset animations for new slide
    setTitleVisible(false);
    setDescVisible(false);

    // Clear previous timeouts to prevent multiple animations
    clearTimeout(titleTimeout.current);
    clearTimeout(descTimeout.current);
    clearTimeout(slideTimeout.current);

    // Title animate first from right after slide change
    titleTimeout.current = setTimeout(() => {
      setTitleVisible(true);
    }, 500);

    // Description animate after 1 second of title from right
    descTimeout.current = setTimeout(() => {
      setDescVisible(true);
    }, 1500); // 500ms + 1000ms = 1500ms

    // Move to next slide after delay
    slideTimeout.current = setTimeout(() => {
      nextSlide();
    }, 6000);
  };

  const nextSlide = () => {
    setActiveIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setActiveIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const handleMouseMove = (e) => {
    const { innerWidth, innerHeight } = window;
    const moveX = (e.clientX / innerWidth - 0.5) * 100;
    const moveY = (e.clientY / innerHeight - 0.5) * 100;

    setTiltStyle({
      transform: `translate(${moveX}px, ${moveY}px)`,
      transition: "transform 0.15s ease-out",
    });
  };

  const handleMouseEnter = () => {
    arrowTimeout.current = setTimeout(() => {
      setShowArrows(true);
    }, 5000);
  };

  const handleMouseLeave = () => {
    clearTimeout(arrowTimeout.current);
    setShowArrows(false);
    setTiltStyle({
      transform: "translate(0, 0)",
      transition: "transform 0.3s ease-out",
    });
  };

  return (
    <div
      className="new-resolution-banner-slider"
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="new-resolution-banner-slider-wrapper">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`new-resolution-banner-slide ${index === activeIndex
              ? "new-resolution-banner-active"
              : "new-resolution-banner-hidden"
              }`}
          >
            <div className="new-resolution-banner-slide-image">
              {slide?.banner_category === "custom-text" && (  
                <div className="new-resolution-banner-shadow"></div>
              )}
              <img src={slide?.banner_image} alt={slide?.banner_title} />
            </div>
            {slide?.banner_category === "custom-text" && (
              <div className="new-resolution-banner-slide-content" style={tiltStyle}>
                <h2
                  className={`new-resolution-banner-slide-title banner-title-font ${titleVisible && index === activeIndex ? "new-resolution-banner-title-visible" : ""
                    }`}
                >
                  {slide?.banner_title}
                </h2>
                <p
                  className={`new-resolution-banner-slide-description ${descVisible && index === activeIndex ? "new-resolution-banner-desc-visible" : ""
                    }`}
                >
                  {slide?.banner_description}
                </p>
              </div>
            )}


          </div>
        ))}
      </div>

      <button
        className={`new-resolution-banner-arrow new-resolution-banner-left-arrow ${showArrows ? "new-resolution-banner-arrow-visible" : ""
          }`}
        onClick={prevSlide}
      >
        <svg
          width="25"
          height="25"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 18L9 12L15 6"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <button
        className={`new-resolution-banner-arrow new-resolution-banner-right-arrow ${showArrows ? "new-resolution-banner-arrow-visible" : ""
          }`}
        onClick={nextSlide}
      >
        <svg
          width="25"
          height="25"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 18L15 12L9 6"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};

export default ResolutionSlider;